import { Bowser } from '@factorin/util';

import 'Modules/business/cryptopro';

/* global cadesplugin */
export const allowedOids = {
    '1.2.643.2.2.19': cadesplugin.CADESCOM_HASH_ALGORITHM_CP_GOST_3411,

    '1.2.643.7.1.1.1.1': cadesplugin.CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_256,
    '1.2.643.7.1.1.1.2': cadesplugin.CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_512,

    '1.2.643.7.1.1.2.2': cadesplugin.CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_256,
    '1.2.643.7.1.1.2.3': cadesplugin.CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_512,
};

export const hashAlgorithmMap = {
    '1.2.643.2.2.19': 'GOST3411',

    '1.2.643.7.1.1.1.1': 'GOST3411_2012_256',
    '1.2.643.7.1.1.1.2': 'GOST3411_2012_512',

    '1.2.643.7.1.1.2.2': 'GOST3411_2012_256',
    '1.2.643.7.1.1.2.3': 'GOST3411_2012_512',
};

export const cryptoProPluginAbout = 'https://www.cryptopro.ru/products/cades/plugin/';
export const cryptoProPluginDownload = 'https://www.cryptopro.ru/products/cades/plugin/get_2_0';
export const cryptoProLinks = {
    [Bowser.BROWSER_MAP.chrome]: 'https://chrome.google.com/webstore/detail/cryptopro-extension-for-c/iifchhfnnmpdbibifmljnfjhpififfog?hl=ru',
    [Bowser.BROWSER_MAP.yandex]: 'https://addons.opera.com/ru/extensions/details/cryptopro-extension-for-cades-browser-plug-in/',
    [Bowser.BROWSER_MAP.opera]: 'https://addons.opera.com/ru/extensions/details/cryptopro-extension-for-cades-browser-plug-in/',
    [Bowser.BROWSER_MAP.firefox]: 'https://www.cryptopro.ru/sites/default/files/products/cades/extensions/firefox_cryptopro_extension_latest.xpi',
    [Bowser.BROWSER_MAP.edge]: 'http://cryptopro.ru/sites/default/files/products/cades/nmcades_uwp/nmcades_uwp.docx',
};
